import { render, staticRenderFns } from "./PurchHosipitalAsset.vue?vue&type=template&id=665ff5f0&scoped=true"
import script from "./PurchHosipitalAsset.vue?vue&type=script&lang=js"
export * from "./PurchHosipitalAsset.vue?vue&type=script&lang=js"
import style0 from "./PurchHosipitalAsset.vue?vue&type=style&index=0&id=665ff5f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665ff5f0",
  null
  
)

export default component.exports